import React, { forwardRef, useId } from "react";
import {
  FormControl,
  FormHelperText,
  FormLabel,
  InputBase,
  type InputBaseProps,
} from "@mui/material";
import { TextInputSkeleton } from "../TextInputSkeleton/TextInputSkeleton";

export type TextInputProps = {
  label: string;
  helperText?: string;
  loading?: boolean;
  initialLoading?: boolean;
} & InputBaseProps;

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  (
    {
      id,
      label,
      required = false,
      error = false,
      disabled = false,
      initialLoading = false,
      helperText,
      ...inputProps
    },
    ref
  ) => {
    const generatedId = useId();
    const inputId = id ?? generatedId;
    const helperTextId = helperText ? `${inputId}-helper-text` : undefined;

    return (
      <FormControl
        fullWidth
        required={required}
        error={error}
        disabled={disabled}
      >
        <FormLabel htmlFor={inputId}>{label}</FormLabel>

        {initialLoading ? (
          <TextInputSkeleton />
        ) : (
          <InputBase
            {...inputProps}
            id={inputId}
            inputRef={ref}
            disabled={disabled}
            error={error}
            aria-invalid={error || undefined}
            aria-describedby={helperTextId}
          />
        )}

        {helperText && (
          <FormHelperText id={helperTextId}>{helperText}</FormHelperText>
        )}
      </FormControl>
    );
  }
);

TextInput.displayName = "TextInput";

export default TextInput;